package com.devi3east.bashbuddy.search.ui

import com.devi3east.bashbuddy.features.events.common.data.models.Event

data class SearchUiState(
    val isLoading: Boolean = false,
    val errorMessage: String? = null,
    val eventsList: List<Event> = emptyList()
)